import { useEffect } from 'react';
import { identifyPostHogUser, resetPostHogUser } from '@/utils/posthog';
import { AuthUser } from '@/api-types';

/**
 * Hook to automatically sync user context with PostHog
 * Use this in your app's root or authentication provider
 */
export function usePostHogUser(user: AuthUser | null) {
  useEffect(() => {
    if (user) {
      identifyPostHogUser(user.id, {
        email: user.email,
        name: user.displayName,
        username: user.displayName,
      });
    } else {
      resetPostHogUser();
    }
  }, [user]);
}

